import React from 'react';
import { Link } from 'react-router-dom';
import StylePicker from '../components/campaign/StylePicker';
import ContentBody, { Sources } from '../components/editorial/ContentBody';
import Faq from '../components/Faq';

// The parent supplies release-filtered links and owns routing and metadata.
export default function CampaignToolPage({ page }) {
  return <div className="campaign-page" data-testid={`campaign-${page.id}`}>
    <header className="content-narrow page-hero">
      <h1 className="hero-title">{page.title}</h1>
      <p className="hero-intro">{page.answer}</p>
    </header>
    <div className="content-narrow">
      <StylePicker key={page.id} mode={page.mode} initialText={page.mode === 'big' ? 'BIG' : 'Hello world'} />
    </div>
    <section className="content-narrow prose-site py-12" aria-label="How to use this tool">
      <ContentBody blocks={page.body} lang="en" />
      <Sources items={page.sources} lang="en" />
      {!!page.links?.length && <nav aria-label="Related tools and guides">
        <h2>Related tools and guides</h2>
        <ul>{page.links.map(link => <li key={link.to}><Link to={link.to}>{link.text}</Link></li>)}</ul>
      </nav>}
    </section>
    <Faq items={page.faq} title="Frequently Asked Questions" />
  </div>;
}
